import React from 'react';

const ProjectCard = (props) => {

    return (
        <div className='card flex flex-col w-[85%] h-[90%] bg-[#1c2333] bg-clip-padding backdrop-filter backdrop-blur-lg border border-gray-800 rounded-xl justify-between items-center mb-5'>
            {/* <div id="circle" ctlassName='absolute w-2 aspect-square rounded-full' style={{ boxShadow: '0 0 20px rgba(255, 255, 255, 1)', backgroundColor: 'rgba(255, 255, 255, 0.7' }}></div> */}
            <h2 className='text-white text-3xl font-poppins text-center pt-5 h-[15%] font-semibold'>{props.title}</h2>
            <div className='flex items-center justify-center w-full h-[75%]'>
                <img src={ props.src } alt={ props.alt } className='h-[400px] max-h-[90%] max-w-[90%] self-center justify-self-center'/>
            </div>
            <div className='h-[10%] w-10 mb-2 flex justify-center items-center'>
                {props.info.map((item) => (
                    <img src={item.img} title={item.alt} className='h-[90%] p-1 opacity-30 hover:opacity-100'></img>
                ))}
            </div>
        </div>
    );
};

export default ProjectCard;
